import { render, staticRenderFns } from "./FilterFragments.vue?vue&type=template&id=31a40d17&scoped=true"
import script from "./FilterFragments.vue?vue&type=script&lang=js"
export * from "./FilterFragments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a40d17",
  null
  
)

export default component.exports